module.exports = __webpack_public_path__ + "static/media/dingdingliuchengtu.ec7791f6.png";